import React from 'react';
import './Budget.scss';
import AdminMenu from '../../../components/AdminMenu/AdminMenu';
import AttachementField from '../../../components/AttachementField/AttachementField';
import '../../../resources/adminStyle.scss';
import AuthenticationService from '../../../services/AuthenticationService';
import {budgetService} from '../../../services/BudgetService';
import NotificationSystem from 'react-notification-system';
import DeletePUGCertificates from '../../../components/DeleteDialog/DeleteDialog';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import DocumentOpenManager from '../../../managers/DocumentOpenManager';

const documentOpenManager = new DocumentOpenManager();

class Budget extends React.Component{
    constructor(props){
        super(props)
        this.state={
           newBudget:{
            title:'',
            date:'',
            document:''
           },
           existingBudgets:[],
           deleteBudget: {
            openedDialog: false,
            deleteId: 0
          },
          pagination: {}
        }
        this.authentication = new AuthenticationService();
    }
    handleChange=event=>{
        let newBudget = { ...this.state.newBudget };
        newBudget[event.target.name] = event.target.value;
  
          this.setState({ newBudget });
      }

    
      componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        budgetService
        .getAll()
        .then(response => {
          this.setBudgetState(response);
        })
        .catch(error => {
          console.log(error);
        });
      }
      setBudgetState = response => {
        let existingBudgets = this.state.existingBudgets;
        existingBudgets = response.budgets;
        this.setState({
            existingBudgets
        });
        let pagination = { ...this.state.pagination };
        pagination = response.pagination;
        this.setState({
          pagination
        });
      };
      handlePageClick = currentPage => {
        budgetService
          .getAll(currentPage.selected + 1)
          .then(response => {
            this.setBudgetState(response);
          })
          .catch(error => console.log(error));
      };
      resetForm = () => {
        let newBudget = { ...this.state.newBudget };
        newBudget = {
          title: '',
          date:'',
          document: ''
        };
        this.setState({ newBudget });
        this.setState({ disabledDocument: false });
      };
      openDeleteDialog = id => {
        let deleteBudget = { ...this.state.deleteBudget };
        deleteBudget = {
          openedDialog: true,
          deleteId: id
        };
    
        this.setState({ deleteBudget });
      };
    
      closeDeleteDialog = () => {
        let deleteBudget = { ...this.state.deleteBudget };
        deleteBudget = {
          openedDialog: false,
          deleteId: 0
        };
    
        this.setState({ deleteBudget });
      };
      handleFormSubmit = event => {
        event.preventDefault();
    
        budgetService
          .createOrUpdate(this.state.newBudget)
          .then(response => {
            this.resetForm();
    
            let existingBudgets = this.state.existingBudgets;
    
            let index = existingBudgets.findIndex(
              existingBudgets => existingBudgets.id === response.id
            );
    
            if (index !== -1) {
              existingBudgets[index] = response;
            } else {
              existingBudgets.push(response);
            }
    
            this.setState({
              existingBudgets
            });
    
            this._notificationSystem.addNotification({
              message: `Bugetul a fost ${
                this.state.newBudget.id ? 'editat' : 'adaugat'
              } cu success.`,
              level: 'success',
              position: 'tc'
            });
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problemă la adăugare, faceti refresh la pagina sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
      onDropDocument = documents => {
        let newBudget = { ...this.state.newBudget };
        let reader = new FileReader();
        let self = this;
    
        reader.onload = function(upload) {
          newBudget.document = documents[0];
    
          self.setState({ newBudget });
          self.setState({ disabledDocument: true });
        };
        reader.readAsDataURL(documents[0]);
      };
    
      removeDocument = () => {
        let newBudget = { ...this.state.newBudget };
        newBudget.document = null;
    
        this.setState({ newBudget });
        this.setState({ disabledDocument: false });
      };
    
      setBudgetForEdit = (event, budget) => {
          event.preventDefault();

        let newBudget = { ...this.state.newBudget };
        newBudget = Object.assign({}, budget);
        this.setState({ newBudget });
    
        if (newBudget.document && newBudget.document.url) {
          this.setState({ disabledDocument: true });
        }
      };
    
      handleDelete = () => {
        budgetService
          .deleteBudget(this.state.deleteBudget.deleteId)
          .then(() => {
            let existingBudgets = this.state.existingBudgets.slice();
            existingBudgets = existingBudgets.filter(
              budget => budget.id !== this.state.deleteBudget.deleteId
            );
            this.setState({ existingBudgets });
    
            this.closeDeleteDialog();
    
            this._notificationSystem.addNotification({
              message: 'Bugetul a fost șters cu success.',
              level: 'success',
              position: 'tc'
            });
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problema la ștergere, faceți refresh la pagină sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
    render(){
        return(
            <div className='admin'>
                <AdminMenu/>
                <div className='admin__wrapper'>
                    <h2 className='admin__title'>Buget</h2>
                    <h3 className='admin__subtitle'>Adaugă un buget:</h3>
                        <form className='admin__form' onSubmit={this.handleFormSubmit}>
                            <h4 className='admin__label'>Titlu document:</h4>
                            <input
                                className="admin__field"
                                type="text"
                                name="title"
                                onChange={this.handleChange}
                                required
                                value={this.state.newBudget.title}/>
                            <h4 className='admin__label'>Data:</h4>
                            <input
                                className="admin__field"
                                type="date"
                                name="date"
                                required
                                onChange={this.handleChange}
                                value={this.state.newBudget.date}/>
                            <div className='admin__attachement'>
                                <AttachementField
                                onDrop={this.onDropDocument}
                                removeDocument={this.removeDocument}
                                document={this.state.newBudget.document}
                                documentFilename={
                                    this.state.newBudget.document_filename
                                }
                                />
                            </div>
                            <button type='submit' className='admin__submit-button'> {this.state.newBudget.id
                        ? 'Editează'
                        : 'Adaugă'} bugetul</button>       
                        </form>
                        <div className='admin__existing-documents'>
                        {this.state.existingBudgets && this.state.existingBudgets.length?  <h3 className='admin__no-documents'> Documente existente:</h3> : ''} 
                        {this.state.existingBudgets && this.state.existingBudgets.length? 
                        <div className='admin__existing-docs-wrapper'>
                         {this.state.existingBudgets.map(budget=>
                            ( <div className='admin__card'>
                                 <h3 className='admin__card-title'>{budget.title}</h3>
                                 <div className='admin__date-box'>
                                    <img src='/images/icons/calendar.png' alt='calendar'/>
                                    <h4 className='admin__card-date'>{budget.date}</h4>
                                 </div>
                                 <div className='admin__document-box'  onClick={() =>
                                    documentOpenManager.open(budget.document)
                                    }>
                                     <img src='/images/icons/file.png' alt='file'/>
                                     <h3 className='admin__document-name'>Vezi document</h3>
                                 </div>
                                 <div className='admin__actions'>
                                    <h4 className='admin__edit' onClick={event => this.setBudgetForEdit(event, budget)} >Editează</h4>
                                    <h4 className='admin__delete'  onClick={() => this.openDeleteDialog(budget.id)}>Șterge</h4>
                                 </div>
                             </div>)
                         )}
                         </div>: 
                        <h3 className='admin__no-documents'> Nu sunt documente adăugate.</h3>
                    }
                       
                               
                        </div>
                </div>
                <NotificationSystem
                    ref="notificationSystem"
                    style={NotificationSystemStyle}
                    />
                 <DeletePUGCertificates
                    opened={this.state.deleteBudget.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteți sigur că doriti să ștergeti acest buget?"
                    aditionalText="Dupa ștergere, bugetul nu va mai putea fi recuperat."
                  />
            </div>
        )
    }
}
export default Budget;